module.exports = __webpack_public_path__ + "img/login-logo.25352746.png";